<h4 *ngIf="data.changeOrder_ID == undefined" mat-dialog-title i18n>Email Quote to Customer</h4>
<h4 *ngIf="data.changeOrder_ID != undefined" mat-dialog-title i18n>Email Change Order to Customer</h4>
<div mat-dialog-content>
  <p i18n>To add a message to the body of an email, fill in the message field or click send to just send the quote.</p>
  <form #statusForm="ngForm" (ngSubmit)="sendEmail(statusForm)">
    <div>
      <h5 *ngIf="data.contacts.length==0" i18n>No contact found for customer</h5>
      <div *ngFor="let contact of data.contacts" class="form-group row">
        <label for="quoteEmail_Message" class="col-sm-6 col-form-label">
          {{contact.contact_FirstName}} {{contact.contact_LastName}}
          ({{contact.contact_Email}})
        </label>

        <div class="col-sm-3">
          <input type="checkbox" name="contact_selected_{{contact.contact_ID}}"
                 id="contact_selected_{{contact.contact_ID}}"
                 class="bidit-switch-rg" [(ngModel)]="contact.selected" />
          <span i18n>Send</span>
        </div>
      </div>
      <div class="form-group row">
        <label for="quoteEmail_Message" class="col-sm-6 col-form-label">
          <strong>CC</strong>
          ({{user_email}})
        </label>
        <div class="col-sm-3">
          <input type="checkbox" name="cc_selected"
                 id="cc_selected"
                 class="bidit-switch-rg" [(ngModel)]="cc_selected" />
          <span i18n>Send</span>
        </div>
      </div>
      <div class="form-group row">
        <div *ngFor="let assignedSalesPerson of data.quoteAssignments" class="form-group row">
          <label for="quoteEmail_assignment" class="col-sm-6 col-form-label">
            <strong>CC</strong>
            {{assignedSalesPerson.assignedTo.firstName}} {{assignedSalesPerson.assignedTo.lastName}}
            ({{assignedSalesPerson.assignedTo.email}})
          </label>

          <div class="col-sm-3">
            <input type="checkbox" name="sp_selected_{{assignedSalesPerson.quote_AssignedTo}}"
                   id="sp_selected_{{assignedSalesPerson.quote_AssignedTo}}"
                   class="bidit-switch-rg" [(ngModel)]="assignedSalesPerson.selected" />
            <span i18n>Send</span>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="quoteEmail_Message" class="col-sm-4 col-form-label" i18n>Message</label>
        <div class="col-sm-8">
          <textarea class="form-control" name="quoteEmail_Message" id="quoteEmail_Message"
                    rows="3"
                    [(ngModel)]="data.quoteEmail_Message" #quoteEmail_Message="ngModel">
        </textarea>
        </div>
      </div>
      <div class="form-group row">
        <label for="quote_ContractNotes" class="col-sm-4 col-form-label" i18n>Contract Notes</label>
        <div class="col-sm-8">
          <textarea class="form-control" name="quote_ContractNotes" id="quote_ContractNotes"
                    rows="3"
                    [(ngModel)]="data.quote_ContractNotes" #quote_ContractNotes="ngModel">
              </textarea>
        </div>
      </div>
      <div>
        <mat-checkbox id="groupAreas" name="groupAreas" class="col-form-label" [(ngModel)]="groupAreas" i18n>Group Areas</mat-checkbox>
      </div>
      <div class="form-inline">
        <div class="col-sm-4">
          <mat-checkbox id="showSquareFootage" name="showSquareFootage" class="col-form-label" [(ngModel)]="data.showSquareFootage" i18n>Show Square Footage</mat-checkbox>
        </div>
        <div class="col-sm-4">
          <mat-checkbox id="showPricing" name="showPricing" class="col-form-label" [(ngModel)]="data.showPricing" i18n>Show Item Pricing</mat-checkbox>
        </div>
      </div>
      <div class="form-group form-inline">
        <div class="col-sm-4">
          <mat-checkbox id="showTaxes" name="showTaxes" class="col-form-label" [(ngModel)]="data.showTaxes" i18n>Show Tax</mat-checkbox>
        </div>
        <div class="col-sm-4">
          <mat-checkbox id="hideItemNotes" name="hideItemNotes" class="col-form-label" [(ngModel)]="data.hideLineItemNotes" i18n>Hide Line Item Notes</mat-checkbox>
        </div>
      </div>
      <div class="form-group">
        <select name="locale" class="form-control select-bidit" [(ngModel)]="locale">
          <option value="en">English</option>
          <option value="es">Español</option>
        </select>
      </div>
      <app-dealer-document-selection *ngIf="this.showDocuments" (selectionUpdated)="documentSelectionUpdated($event)" (documentsLoaded)="loadDocuments($event)"></app-dealer-document-selection>

      <div class="form-group float-right" *ngIf="!isRequesting">
        <button mat-button type="button" (click)="showQuoteDocuments()" class="btn btn-outline-primary mr-1" i18n>Attach Documents</button>
        <button mat-button type="submit" class="btn btn-bidit-submit mr-1" i18n>Submit</button>
        <button mat-button type="button" (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
      </div>
      <app-spinner [isRunning]="isRequesting"></app-spinner>
    </div>
  </form>
</div>
